import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IWaterSystemsData, WaterSystemsInitialState } from '../waterSystems.slice';
import { AxiosResponse} from 'axios';
import { EpaApi } from '../../../services';

export const fetchPublicWaterSystemsByAddressAsync = createAsyncThunk(
    'systems/fetchSystemsByAddress',
    async ({ latitude, longitude, radius }: { latitude: number, longitude: number, radius?: number },
   { rejectWithValue }) => {
      try {

        const response = await EpaApi.fetchPublicWaterSystemsByAddress(latitude, longitude, radius);
        return (response as AxiosResponse<any,any>).data;
      } catch (error: any) {
        console.error(error);
        return rejectWithValue({
          message: error?.response?.data?.message || "Unexpected error occurred"
        });
      }
    }
  );

export const fetchPublicWaterSystemsByAddressAsyncBuilder = (
    builder: ActionReducerMapBuilder<WaterSystemsInitialState>
  ) => {
    builder.addCase(fetchPublicWaterSystemsByAddressAsync.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = '';
    })
    builder.addCase(
      fetchPublicWaterSystemsByAddressAsync.fulfilled,
      (state, action: PayloadAction<IWaterSystemsData>) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      }
    )
    builder.addCase(
      fetchPublicWaterSystemsByAddressAsync.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      }
    )
  }